module.exports = __webpack_public_path__ + "img/2.4c3959f6.png";